export const ETH_REQUIRED_FOR_SEND = 0.000001;
